export {CardContainer as Card} from './container';
export {CardSkeleton} from './skelton';

export type CardType = 'regular-carousel' | 'top-carousel' | 'standalone';

export type SponsoredCompany = {
  id: number;
  name: string;
  // logoURL?: string;
};
export type SponsoredOption =
  | {
      enabled: false;
    }
  | {
      enabled: true;
      companies: SponsoredCompany[];
    };
